module.exports = __webpack_public_path__ + "img/advantage2.fd4c1ce4.png";